import styled from "styled-components";

export const StyledPosts = styled.div`
  width: 100%;
  margin-top: 1rem;

  .infinite {
    padding: 20px;
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
    gap: 2rem;
    position: relative;
    overflow: auto;
    padding-bottom: 4rem;
    justify-content: space-between;
  }

`;
